import React from "react";
import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Expansion from "storybookComponents/Expansion";
import Icon from "storybookComponents/Icon";
import Loader from "storybookComponents/Loader";
import Typography from "storybookComponents/Typography";
import { appsAndHubs } from "data/appSwitcher";
import { switcherNotify_link } from "data/mockdata";
import { getBanner, setCurrentDate } from "services";
import * as apis from "relay/main";
import Banner from "storybookComponents/Banner";
import { UnAuthIconAppSwitcher, DiamondIconAppSwitcher } from "icons";
import Slides from "components/SuccessCenterSlides"
const styles = theme => ({
  root: {
    position: "relative",
    width: "-webkit-fill-available",
    height: "calc(100vh - 112px)",
    overflowY: "auto",
    margin: 24,
  },
  closeIcon: {
    position: "absolute",
    cursor: "pointer",
    right: 16,
    top: 16,
    zIndex: 1000,
    [theme.breakpoints.up("md")]: {
      right: 20,
      top: 20
    },
    [theme.breakpoints.down("xs")]: {
      display: "none"
    },
    padding: 8,
    borderRadius: "50%",
    width: 36,
    height: 36,
    "&:hover": {
      background: "#f5f5f5"
    }
  },
  expansion: {
    display: "flex"
  },
  expansionBody: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  icon: {
    transform: "rotate(270deg)",
    marginRight: 8
  },
  mediumApp: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: 16,
    margin: 8,
    border: "1px solid #EEE",
    width: 220,
    height: 220,
    cursor: "pointer",
    "&:hover": {
      background: "#26bbed"
    },
    "&:hover $mediumAppIcon": {
      color: "#fff !important"
    },
    "&:hover $mediumAppTitle": {
      color: "#fff !important"
    },
    "&:hover $mediumAppSubTitle": {
      color: "#fff !important"
    },
    "&:hover svg": {
      stroke: "white !important"
    },
    "&:hover path": {
      stroke: "white !important"
    }
  },
  smallApp: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: 16,
    margin: 8,
    borderRadius: 20,
    width: 100,
    height: 100,
    cursor: "pointer",
    "&:hover": {
      background: "#26bbed"
    },
    "&:hover $smallAppIcon": {
      color: "#fff !important"
    },
    "&:hover $smallTitle": {
      color: "#fff !important"
    },
    "&:hover svg": {
      stroke: "white !important"
    },
    "&:hover path": {
      stroke: "white !important"
    }
  },
  activeSmallApp: {
    border: "1px solid #999"
  },
  disableSmallApp: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: 16,
    margin: 8,
    borderRadius: 20,
    width: 100,
    height: 100,
    pointerEvents: "none"
  },
  smallAppIcon: {
    margin: 8,
    width: 24,
    height: 24,
    fontSize: 24
  },
  mediumAppIcon: {
    width: 48,
    height: 48,
    fontSize: 48,
    marginTop: 24
  },
  mediumAppTitle: {
    margin: 16
  },
  separator: {
    borderBottom: "1px solid #EEE",
    width: "20%"
  },
  smallTitle: {
    width: 90,
    fontSize: 16
  },
  banner: {
    background: "#E75F75",
    padding: "8px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  bannerAction: {
    display: "flex",
    alignItems: "center"
  },
  bannerClose: {
    display: "flex",
    color: "#fff",
    cursor: "pointer !important",
    marginLeft: 20
  },
  mediumAppSubTitle: {},
  section: {
    fontWeight: 600,
    fontFamily: "Open Sans",
    display: "flex",
    gap: "12px"
  },
  sectionBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "6px 16px",
    width: "219px",
    height: "32px",
    left: "140px",
    top: "318px",
    background: "rgba(38, 187, 237, 0.1)",
    borderRadius: "4px",
    fontFamily: 'Open Sans',
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    textTransform: "capitalize",
    color: "#333333",
  },
  sectionTryBtn: {
    color: "#4F6FAE",
    "&:hover": {
      color: "#26bbed"
    }
  },
  subContainer: {
    background: "white",
    paddingBottom: 24,
    border: "1px solid #dadada"
  },
  iconContainer: {
    position: "absolute",
    top: 8,
    right: 8,
    lineHeight: "16px",
    display: "none",
  },
  premiumApp: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: 16,
    margin: 8,
    borderRadius: 20,
    width: 100,
    height: 100,
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      background: "rgba(38, 187, 237, 0.06)",
    },
    "&:hover $iconContainer": {
      display: "block",
    },
    "&:hover $smallAppIcon": {
      color: "initial !important",
    },
  },
  unauthApp: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: 16,
    margin: 8,
    borderRadius: 20,
    width: 100,
    height: 100,
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      background: "#f9f9f9",
    },
    "&:hover $iconContainer": {
      display: "block",
    },
    "&:hover $smallAppIcon": {
      color: "initial !important",
    },
  },
});

const SmallApp = ({ classes, svg, icon, title, url, handleClick, active, unauth, premium, handleSlidesOpen, unauthSection }) => {
  const handleIconClick = () => {
    if (premium || unauth) {
      let name = title === "Refer-a-Friend" ? "Raf" : title;
      handleSlidesOpen(name)
    } else if (url && url.includes("http")) handleClick(url);
  };

  return (
    <div
      className={
        unauthSection
          ? `${classes.disableSmallApp}`
          :
          active
            ? `${classes.smallApp} ${classes.activeSmallApp}`
            : premium
              ? `${classes.premiumApp}`
              : unauth
                ? `${classes.unauthApp}`
                : url && url.includes("http")
                  ? `${classes.smallApp}`
                  : `${classes.disableSmallApp}`
      }
      onClick={handleIconClick}
    >
      {svg ? (
        <span dangerouslySetInnerHTML={{ __html: icon }} />
      ) : (
        <i className={`icon ${icon} ${classes.smallAppIcon}`} />
      )}
      <div className={classes.iconContainer}>
        {premium ? <DiamondIconAppSwitcher /> : unauth ? <UnAuthIconAppSwitcher /> : null}
      </div>
      <Typography type="body1" color="black" className={classes.smallTitle}>
        {title}
      </Typography>
    </div>
  );
};

class AppSwitcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      activeApp: "hyRaf",
      apps: [],
      hubs: [],
      notAuthorized: [],
      appSection: true,
      notAuthorizedSection: true,
      banner: getBanner(),
      tour: false,
      journeyAIModulesSection: true,
      appName: null
    };
    this.timerID = "";
  }

  async componentDidMount() {
    let allApps = this.props.apps;
    if (allApps) {
      var data = await this._loadApps(allApps);
      if (data) {
        var apps = data.filter((d) => d.appOrHub === "App" && d.authorized && !d.journeyAIModules);
        var hubs = data.filter(
          d => d.appOrHub === "Hub" && d.authorized && !d.journeyAIModules
        );
        var journeyAIModules = data.filter(d => d.journeyAIModules && !d.unauthUser);
        var notAuthorized = data.filter(
          d => (!d.authorized || !d.access) && d.title !== "Journey AI Suite" && !d.journeyAIModules
        );
        this.setState(
          {
            apps,
            hubs,
            notAuthorized,
            journeyAIModules,
            loading: false
          },
          () => {
            this.timerID = setTimeout(
              () =>
                this.setState({
                  tour: true
                }),
              200
            );
          }
        );
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timerID);
  }
  goToRaf = (event) => {
    event.stopPropagation();
    window.open(process.env.REACT_APP_JAI_hostName + "/" + this.props.property.id + "/home");
  };
  handleClick = url => {
    if (url.includes("https://my.")) {
      return window.open(
        `${url.replace(/\/$/, "")}?cognito_token=${this.props.token}`,
        "_blank"
      );
    } else {
      return window.open(`${url}`, "_blank");
    }
  };
  handleSlidesOpen = (appName) => {
    this.setState({
      appName
    })
  }

  handleCloseCallBack = () => {
    this.setState({
      appName: null
    })
  };
  _loadApps = allApps => {
    var myApps = allApps.reduce((r, e) => {
      let icon = this.getIcon(e.name);
      r.push({
        id: e.id,
        title: e.name,
        icon: icon.icon,
        svg: icon.svg,
        url: e.url,
        appOrHub: e.appOrHub ? e.appOrHub : "App",
        authorized: e.authorized,
        journeyAIModules: e.journeyAIModules,
        premium: e.premium,
        unauthUser: e.unauthUser,
        access: e.access !== "none"
      });
      return r;
    }, []);

    var hyBlast = appsAndHubs.find(app => app.name === "hyBlast");
    var hySurvey = appsAndHubs.find(app => app.name === "hySurvey");
    var checkhyBlast = myApps.find(app => app.title === "hyBlast");
    var checkhySurvey = myApps.find(app => app.title === "hySurvey");
    if (!checkhySurvey)
      myApps.push({
        id: hySurvey.id,
        title: hySurvey.name,
        icon: hySurvey.icon,
        url: hySurvey.url,
        appOrHub: hySurvey.appOrHub,
        authorized: hySurvey.authorized
      });
    if (!checkhyBlast)
      myApps.push({
        id: hyBlast.id,
        title: hyBlast.name,
        icon: hyBlast.icon,
        url: hyBlast.url,
        appOrHub: hyBlast.appOrHub,
        authorized: hyBlast.authorized
      });
    return myApps;
  };

  getIcon = name => {
    var icon = appsAndHubs.find(e => e.name === name);
    if (icon) return icon;
    else return { icon: "icon-system-update" };
  };

  handleChange = (expanded, sectionName) => {
    if (sectionName === "appSection") {
      this.setState({
        appSection: !this.state.appSection
      });
    } else if (sectionName === "notAuthorizedSection") {
      this.setState({
        notAuthorizedSection: !this.state.notAuthorizedSection
      });
    }
    else if (sectionName === "journeyAIModulesSection") {
      this.setState({
        journeyAIModulesSection: !this.state.journeyAIModulesSection,
      });
    }
  };

  handleLearn = () => {
    setCurrentDate();
    this.setState(
      {
        banner: false
      },
      () => window.open(`${switcherNotify_link}`, "_blank")
    );
  };

  handleCancel = () => {
    setCurrentDate();
    this.setState({
      banner: false
    });
  };

  render() {
    const { classes, closeAppSwitcher } = this.props;
    const {
      loading,
      activeApp,
      apps,
      hubs,
      notAuthorized,
      appSection,
      notAuthorizedSection,
      banner,
      journeyAIModules,
      journeyAIModulesSection, } = this.state;

    if (loading) {
      return <Loader />;
    } else {
      return (
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Slides showSlides={this.state.appName} appName={this.state.appName} handleCloseCallBack={this.handleCloseCallBack} />
            <div className={classes.root}>
              <div className={classes.subContainer}>


                {/* {tour && (
                <HylyTour
                  type="switcher"
                  hubs={hubs}
                  notAuthorized={notAuthorized}
                />
              )} */}

                {/* {banner && (
                <Banner
                  banner="The App Switcher has been improved! Jump over to our KB to
                  learn more."
                  laterButton="Later"
                  actionButton="Learn More"
                  handleLater={this.handleCancel}
                  handleAction={this.handleLearn}
                />
              )} */}

                <div
                  className={classes.closeIcon}
                  onClick={closeAppSwitcher}
                >
                  <Icon type="icon-e-remove" size="md" />
                </div>

                <Expansion
                  controlled
                  open={appSection}
                  defaultPadding
                  id="appSection"
                  type="children"
                  section={<div className={classes.section}>My Apps & Hubs</div>}
                  children={
                    <div>
                      <div className={`${classes.expansionBody} ss-1`}>
                        {apps &&
                          apps.length > 0 &&
                          apps.map((app, index) => (
                            <SmallApp
                              key={"app-" + index}
                              {...this.props}
                              svg={app.svg}
                              icon={app.icon}
                              title={app.title}
                              url={app.url}
                              handleClick={this.handleClick}
                              active={app.title === activeApp ? true : false}
                            />
                          ))}
                      </div>

                      {hubs && hubs.length > 0 && (
                        <div>
                          <div class={classes.separator}></div>
                          <div className={`${classes.expansionBody} ss-2`}>
                            {hubs.map((app, index) => (
                              <SmallApp
                                key={"app-" + index}
                                {...this.props}
                                svg={app.svg}
                                icon={app.icon}
                                title={app.title}
                                url={app.url}
                                handleClick={this.handleClick}
                                active={app.title === activeApp ? true : false}
                              />
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  }
                  checkIcon={false}
                  disabled={false}
                  handleChange={this.handleChange}
                />

                {notAuthorized && notAuthorized.length > 0 && (
                  <Expansion
                    controlled
                    open={notAuthorizedSection}
                    defaultPadding
                    id="notAuthorizedSection"
                    type="children"
                    section={<div className={classes.section}>Not Authorized</div>}
                    children={
                      <div className={`${classes.expansionBody} ss-3`}>
                        {notAuthorized.map(
                          (app, index) =>
                          (
                            <SmallApp
                              key={"app-" + index}
                              {...this.props}
                              svg={app.svg}
                              icon={app.icon}
                              title={app.title}
                              url={app.url}
                              handleClick={this.handleClick}
                              unauthSection={true}
                            />
                          )
                        )}
                      </div>
                    }
                    checkIcon={false}
                    disabled={false}
                    handleChange={this.handleChange}
                  />
                )}
                {journeyAIModules && journeyAIModules.length > 0 && (
                  <Expansion
                    controlled
                    open={journeyAIModulesSection}
                    defaultPadding
                    id="journeyAIModulesSection"
                    type="children"
                    section={<div className={classes.section}>
                      <div>Journey AI (New)</div>
                      <div className={classes.sectionBtn}>New & Improved.
                        <div className={classes.sectionTryBtn} onClick={this.goToRaf}>&nbsp;Try It Now</div> </div>
                    </div>}
                    children={
                      <div className={`${classes.expansionBody} ss-3`}>
                        {journeyAIModules.map((app, index) => (
                          <SmallApp
                            key={"app-" + index}
                            {...this.props}
                            svg={app.svg}
                            icon={app.icon}
                            title={app.title}
                            url={app.url}
                            handleClick={this.handleClick}
                            premium={app.premium}
                            unauth={app.unauthUser}
                            handleSlidesOpen={this.handleSlidesOpen}
                          />
                        ))}
                      </div>
                    }
                    checkIcon={false}
                    disabled={false}
                    handleChange={this.handleChange}
                  />
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      );
    }
  }
}

export default withStyles(styles)(AppSwitcher);
